function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "circle-exclamation");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "circle-exclamation",
  transform: "translate(0.000000, 0.500000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,0 C4.47656274,0 0,4.47656274 0,10 C0,15.5234373 4.47656274,20 10,20 C15.5234373,20 20,15.5234373 20,10 C20,4.47656274 15.5234373,0 10,0 Z M10,18.75 C5.17578125,18.75 1.25,14.8242188 1.25,10 C1.25,5.17578125 5.17578125,1.25 10,1.25 C14.8242188,1.25 18.75,5.17578125 18.75,10 C18.75,14.8242188 14.8242188,18.75 10,18.75 Z M10,11.875 C10.3454685,11.875 10.625,11.5954685 10.625,11.25 L10.625,5 C10.625,4.65453148 10.3454685,4.375 10,4.375 C9.65453148,4.375 9.375,4.65625048 9.375,5 L9.375,11.25 C9.375,11.5937495 9.65624988,11.875 10,11.875 Z M10,13.4375 C9.48242188,13.4375 9.0625,13.8574219 9.0625,14.375 C9.0625,14.8925781 9.48242188,15.3125 10,15.3125 C10.5175781,15.3125 10.9375,14.8925781 10.9375,14.375 C10.9375,13.8574219 10.5195308,13.4375 10,13.4375 Z",
  id: "Shape"
})));
const SvgIconCircleExclamation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCircleExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-circle-exclamation.e65cacf3.svg";
export { ForwardRef as ReactComponent };